import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeComponent implements OnInit {
  public course1 = {
    id: 1,
    image: "assets/courses/home-thumbnail-2020-1.jpg",
    video: "assets/courses/video1.mp4",
    teacher: {
      name: "Kike",
      email: "kikevilla2000@gmail.com",
      image: "assets/teachers/kike.jpg"
    }
  };
  public course2 = {
    id: 3,
    image: "assets/courses/home-thumbnail-2020-2.jpg",
    video: "assets/courses/video3.mp4",
    teacher: {
      name: "María G",
      email: "glezrodriguezmaria@gmail.com",
      image: "assets/teachers/maria.g.jpg"
    }
  };
  public course3 = {
    id: 2,
    image: "assets/courses/home-thumbnail-2020-3.jpg",
    video: "assets/courses/video2.mp4",
    teacher: {
      name: "María M",
      email: "mirga.mary@icloud.com",
      image: "assets/teachers/maria.m.jpg"
    }
  };

  constructor() {}

  ngOnInit() {}
}
